import { normalizarPalabra, PALABRAS_EMOJI } from './emojisFinanzas';

/**
 * Buscador del selector de emoji: cada palabra escrita tiene que ser el
 * principio de alguna palabra del emoji («super» → 🛒; «comida rap» →
 * 🍕 🍔). Sin tildes ni mayúsculas. Sin texto, lista vacía.
 */
export function buscarEmoji(
  consulta: string,
  palabras: ReadonlyMap<string, readonly string[]> = PALABRAS_EMOJI,
): string[] {
  const trozos = normalizarPalabra(consulta).split(/\s+/).filter(Boolean);
  if (trozos.length === 0) {
    return [];
  }
  let resultado: string[] | null = null;
  for (const trozo of trozos) {
    const encontrados: string[] = [];
    for (const [palabra, emojis] of palabras) {
      if (palabra.startsWith(trozo)) {
        for (const e of emojis) {
          if (!encontrados.includes(e)) {
            encontrados.push(e);
          }
        }
      }
    }
    resultado =
      resultado === null
        ? encontrados
        : resultado.filter(e => encontrados.includes(e));
  }
  return resultado ?? [];
}
